import Attention from '../assets/Attention.svg'
import Creativity from '../assets/Creativity.svg'
import Decisionmaking from '../assets/Decisionmaking.svg'
import Home from '../assets/Home.svg'
import Mental from '../assets/Mental Health.svg'
import Patient from '../assets/Patient Care.svg'
import Performance from '../assets/Performance.svg'
import Personal from '../assets/Personal.svg'
import Physical from '../assets/Physical Health.svg'
import Relationships from '../assets/Relationships.svg'
import Stress from '../assets/Stress.svg'
import Work from '../assets/Work.svg'

import CreativityTagIcon from '../components/Icons/tags/CreativityTagIcon'
import RelationshipsTagIcon from '../components/Icons/tags/RelationshipsTagIcon'
import DecisionTagIcon from '../components/Icons/tags/DecisionTagIcon'
import StressTagIcon from '../components/Icons/tags/StressTagIcon'
import AttentionIcon from '../components/Icons/tags/AttentionIcon'
import MentalHealthIcon from '../components/Icons/tags/MentalHealthIcon'
import PhysicalHealthIcon from '../components/Icons/tags/PhysicalHealthIcon'
import PerformanceIcon from '../components/Icons/tags/PerformanceIcon'
import PersonalIcon from '../components/Icons/tags/PersonalIcon'
import WorkIcon from '../components/Icons/tags/WorkIcon'
import HomeIcon from '../components/Icons/tags/HomeIcon'
import PatientCareIcon from '../components/Icons/tags/PatientCareIcon'

import TextCardIcon from '../components/Icons/TextCardIcon'
import VideoCardIcon from '../components/Icons/VideoCardIcon'
import AudioCardIcon from '../components/Icons/AudioCardIcon'

export const TEXT_TYPE = 'text'
export const VIDEO_TYPE = 'video'
export const AUDIO_TYPE = 'audio'

export const ATTENTION_TAG = 'Attention & Learning'
export const CREATIVITY_TAG = 'Creativity'
export const DECISION_TAG = 'Decision-making'
export const HOME_TAG = 'Home'
export const MENTAL_TAG = 'Mental health'
export const PATIENT_TAG = 'Patient Care'
export const PERFORMANCE_TAG = 'Performance'
export const PERSONAL_TAG = 'Personal'
export const PHYSICAL_TAG = 'Physical health'
export const RELATIONSHIPS_TAG = 'Relationships'
export const STRESS_TAG = 'Stress'
export const WORK_TAG = 'Work'

export const TAG_ICONS_MAP = {
  [ATTENTION_TAG]: Attention,
  [CREATIVITY_TAG]: Creativity,
  [DECISION_TAG]: Decisionmaking,
  [HOME_TAG]: Home,
  [MENTAL_TAG]: Mental,
  [PATIENT_TAG]: Patient,
  [PERFORMANCE_TAG]: Performance,
  [PERSONAL_TAG]: Personal,
  [PHYSICAL_TAG]: Physical,
  [RELATIONSHIPS_TAG]: Relationships,
  [STRESS_TAG]: Stress,
  [WORK_TAG]: Work
}

export const TAG_ICONS_COMPONENTS_MAP = {
  [ATTENTION_TAG]: AttentionIcon,
  [CREATIVITY_TAG]: CreativityTagIcon,
  [DECISION_TAG]: DecisionTagIcon,
  [HOME_TAG]: HomeIcon,
  [MENTAL_TAG]: MentalHealthIcon,
  [PATIENT_TAG]: PatientCareIcon,
  [PERFORMANCE_TAG]: PerformanceIcon,
  [PERSONAL_TAG]: PersonalIcon,
  [PHYSICAL_TAG]: PhysicalHealthIcon,
  [RELATIONSHIPS_TAG]: RelationshipsTagIcon,
  [STRESS_TAG]: StressTagIcon,
  [WORK_TAG]: WorkIcon
}

export const CARD_TYPE_ICONS_MAP = {
  [TEXT_TYPE]: TextCardIcon,
  [VIDEO_TYPE]: VideoCardIcon,
  [AUDIO_TYPE]: AudioCardIcon
}
